/* SAVA Design System v2 — behaviour layer.
   Everything is progressive enhancement: forms and links work without JS. */
(function () {
  'use strict';
  const S = window.SAVA || {};
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const html = document.documentElement;

  const fmt = new Intl.NumberFormat(S.locale || 'en-US', { style: 'currency', currency: S.currency || 'USD' });
  const money = (cents) => fmt.format(cents / 100);

  /* ---------- overlays: drawers, search ---------- */
  let openDrawer = null;
  function lock(on) { html.classList.toggle('is-locked', on); }
  function closeAll() {
    $$('.drawer.is-open').forEach((d) => d.classList.remove('is-open'));
    const sp = $('.search-panel'); if (sp) sp.classList.remove('is-open');
    openDrawer = null; lock(false);
    $$('[data-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
  function openPanel(name) {
    closeAll();
    if (name === 'search') {
      const sp = $('.search-panel'); if (!sp) return;
      sp.classList.add('is-open');
      $$('[data-open="search"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      const input = $('input[type=search]', sp); if (input) setTimeout(() => input.focus(), 40);
      return;
    }
    const d = $(`[data-drawer="${name}"]`); if (!d) return;
    d.classList.add('is-open'); openDrawer = d; lock(true);
    const first = $('[data-close]', d); if (first) first.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const name = opener.getAttribute('data-open');
      const isOpen = name === 'search' ? $('.search-panel.is-open') : $(`[data-drawer="${name}"].is-open`);
      e.preventDefault();
      if (isOpen) closeAll(); else openPanel(name);
      return;
    }
    if (e.target.closest('[data-close]') || e.target.closest('.scrim')) { closeAll(); return; }
    const sp = $('.search-panel.is-open');
    if (sp && !e.target.closest('.search-panel') && !e.target.closest('.hdr')) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- section re-render ---------- */
  async function refreshSections() {
    const targets = $$('[data-section-render]');
    await Promise.all(targets.map(async (el) => {
      const id = el.getAttribute('data-section-render');
      try {
        const res = await fetch(`${location.pathname}${location.search}${location.search ? '&' : '?'}section_id=${id}`, { headers: { Accept: 'text/html' } });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector(`[data-section-render="${id}"]`);
        if (fresh) el.innerHTML = fresh.innerHTML;
      } catch (_) { /* leave stale content in place */ }
    }));
    if (typeof initLazy === 'function') initLazy();
  }
  function setCount(n) { $$('[data-cart-count]').forEach((el) => { el.setAttribute('data-cart-count', n); el.textContent = n; }); }

  /* ---------- cart api ---------- */
  async function cartRequest(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
    return data;
  }
  async function afterCartChange(count) {
    if (typeof count === 'number') setCount(count);
    else { const c = await (await fetch('/cart.js')).json(); setCount(c.item_count); }
    await refreshSections();
  }
  async function addToCart(form, { openDrawerAfter = true } = {}) {
    const fd = new FormData(form);
    const id = fd.get('id'); if (!id) return;
    const qty = parseInt(fd.get('quantity') || '1', 10);
    const btn = $('[type=submit]', form);
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    try {
      await cartRequest('/cart/add.js', { items: [{ id: Number(id), quantity: qty }] });
      await afterCartChange();
      if (openDrawerAfter && $('[data-drawer="cart"]') && !$('[data-cart-page]')) openPanel('cart');
    } catch (err) {
      const note = $('[data-buy-note]', form.closest('[data-product]') || document);
      if (note) note.textContent = err.message; else alert(err.message);
    } finally { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-add]');
    if (form) { e.preventDefault(); addToCart(form); return; }
    const disc = e.target.closest('form[data-discount]');
    if (disc) {
      e.preventDefault();
      const code = ($('input', disc).value || '').trim();
      if (code) location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
    }
  });
  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-qty-step]');
    const rm = e.target.closest('[data-line-remove]');
    if (!step && !rm) return;
    const line = (step || rm).closest('[data-line]'); if (!line) return;
    const key = line.getAttribute('data-line');
    let qty = rm ? 0 : parseInt(line.getAttribute('data-qty'), 10) + parseInt(step.getAttribute('data-qty-step'), 10);
    if (qty < 0) qty = 0;
    line.style.opacity = '.5'; line.style.pointerEvents = 'none';
    try { const cart = await cartRequest('/cart/change.js', { id: key, quantity: qty }); await afterCartChange(cart.item_count); }
    catch (_) { line.style.opacity = ''; line.style.pointerEvents = ''; }
  });

  /* ---------- predictive search ---------- */
  const sInput = $('.search-form input[type=search]');
  if (sInput) {
    const out = $('[data-predictive]'); const idle = $('[data-search-idle]');
    let timer, ctrl;
    sInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = sInput.value.trim();
      if (q.length < 2) { out.innerHTML = ''; if (idle) idle.hidden = false; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        try {
          const url = `${S.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const res = await fetch(url, { signal: ctrl.signal });
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const sec = doc.querySelector('[data-predictive-result]');
          out.innerHTML = sec ? sec.innerHTML : '';
          if (idle) idle.hidden = true;
        } catch (_) { /* aborted */ }
      }, 220);
    });
  }

  /* ---------- infinite scroll ---------- */
  function infinite(root) {
    const anchor = () => $('[data-infinite-anchor]', root);
    let busy = false;
    async function more() {
      const a = anchor(); if (!a || busy) return;
      const next = a.getAttribute('data-next-url'), id = a.getAttribute('data-section-id');
      if (!next || !id) return;
      busy = true;
      const btn = $('[data-load-more]', a), ld = $('[data-loading]', a);
      if (btn) btn.hidden = true; if (ld) ld.hidden = false;
      try {
        const res = await fetch(`${next}${next.indexOf('?') === -1 ? '?' : '&'}section_id=${id}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const ng = $('[data-infinite-grid]', doc), g = $('[data-infinite-grid]', root);
        if (ng && g) g.append(...ng.childNodes);
        const na = $('[data-infinite-anchor]', doc);
        if (na) { a.replaceWith(na); watch(); } else { a.outerHTML = '<p class="feed-end">You’ve seen everything</p>'; }
      } catch (_) { if (btn) btn.hidden = false; }
      busy = false;
    }
    let io;
    function watch() {
      if (io) io.disconnect();
      const a = anchor(); if (!a || !a.getAttribute('data-next-url') || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver((en) => { if (en[0].isIntersecting) more(); }, { rootMargin: '900px 0px' });
      io.observe(a);
    }
    root.addEventListener('click', (e) => { if (e.target.closest('[data-load-more]')) more(); });
    watch();
  }
  $$('[data-infinite-scroll]').forEach(infinite);

  /* ---------- card: secondary image on first hover ---------- */
  document.addEventListener('pointerenter', (e) => {
    if (!(e.target instanceof Element)) return;
    const media = e.target.closest('[data-alt-src]');
    if (!media || media.dataset.altDone) return;
    media.dataset.altDone = '1';
    const img = new Image();
    img.className = 'card__alt'; img.alt = ''; img.loading = 'lazy';
    img.src = media.getAttribute('data-alt-src'); media.appendChild(img);
  }, true);

  /* ---------- filter drawer: apply on change is explicit (Apply button) ---------- */

  /* ---------- product page ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const data = JSON.parse($('[data-variants]', pdp).textContent);
    const form = $('form[data-ajax-add]', pdp);
    const idInput = $('[name=id]', form);
    const track = $('[data-track]', pdp);
    const slides = $$('[data-slide]', pdp);
    const thumbs = $$('[data-thumb]', pdp);
    const counter = $('[data-counter]', pdp);
    const priceEl = $('[data-price]', pdp);
    const btns = $$('[data-submit]', pdp);
    const note = $('[data-buy-note]', pdp);
    const optionEls = $$('[data-option]', pdp);

    function goSlide(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    if (track) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
          if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
        });
      }, { passive: true });
      thumbs.forEach((t, i) => t.addEventListener('click', () => goSlide(i)));
      const step = (d) => { const i = Math.round(track.scrollLeft / track.clientWidth) + d; goSlide(Math.max(0, Math.min(slides.length - 1, i))); };
      $('[data-prev]', pdp) && $('[data-prev]', pdp).addEventListener('click', () => step(-1));
      $('[data-next]', pdp) && $('[data-next]', pdp).addEventListener('click', () => step(1));
    }

    function selected() { return optionEls.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; }); }
    function update() {
      const sel = selected();
      optionEls.forEach((fs, idx) => {
        const label = $('[data-selected]', fs); if (label) label.textContent = sel[idx] || '';
        // mark values with no available variant given the other selections
        $$('input', fs).forEach((inp) => {
          const probe = sel.slice(); probe[idx] = inp.value;
          const match = data.find((v) => v.options.every((o, k) => o === probe[k]));
          const lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-oos', !match || !match.available);
        });
      });
      const v = data.find((x) => x.options.every((o, k) => o === sel[k]));
      if (!v) { btns.forEach((b) => { b.disabled = true; b.textContent = 'Unavailable'; }); return; }
      idInput.value = v.id;
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      priceEl.className = 'price' + (sale ? ' price--sale' : '');
      priceEl.innerHTML = `<span class="price__now">${money(v.price)}</span>` +
        (sale ? `<s>${money(v.compare_at_price)}</s><span class="price__off">-${Math.round((1 - v.price / v.compare_at_price) * 100)}%</span>` : '');
      btns.forEach((b) => {
        b.disabled = !v.available;
        b.textContent = v.available ? (b.dataset.label || 'Add to bag') : 'Sold out';
      });
      const low = v.available && v.inventory_management && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity <= 5;
      note.textContent = low ? `Only ${v.inventory_quantity} left` : (!v.available ? 'This option is currently sold out' : '');
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      if (v.featured_media) {
        const i = slides.findIndex((s) => s.getAttribute('data-media') === String(v.featured_media.id));
        if (i > -1) goSlide(i);
      }
    }
    optionEls.forEach((fs) => fs.addEventListener('change', update));
    update();

    /* sticky buy bar appears once the main button leaves the viewport */
    const main = $('[data-main-submit]', pdp), bar = $('[data-stickybar]');
    if (main && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver((en) => bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0)).observe(main);
    }

    /* recently viewed — real, per-browser */
    try {
      const key = 'sava_rv', cur = pdp.getAttribute('data-handle');
      const list = JSON.parse(localStorage.getItem(key) || '[]').filter((h) => h !== cur);
      list.unshift(cur); localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (_) {}
  }

  /* recommendations + recently viewed (progressive, below the fold) */
  function lazyLoad(el, fn) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { fn(); return; }
    const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); fn(); } }, { rootMargin: '600px 0px' });
    io.observe(el);
  }
  function initLazy() {
  const rec = $('[data-recommendations]');
  lazyLoad(rec, async () => {
    try {
      const res = await fetch(rec.getAttribute('data-url'));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const content = $('[data-rec-result]', doc);
      if (content && $('.card', content)) rec.innerHTML = content.innerHTML;
    } catch (_) {}
  });
  const rv = $('[data-recent]');
  lazyLoad(rv, async () => {
    try {
      const cur = rv.getAttribute('data-current');
      const handles = JSON.parse(localStorage.getItem('sava_rv') || '[]').filter((h) => h !== cur).slice(0, 6);
      if (!handles.length) return;
      const cards = await Promise.all(handles.map(async (h) => {
        const res = await fetch(`/products/${h}?section_id=card-render`);
        if (!res.ok) return '';
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const c = $('.card', doc); return c ? c.outerHTML : '';
      }));
      const joined = cards.filter(Boolean).join('');
      if (joined) rv.innerHTML = '<div class="container"><div class="sec-head"><h2 class="h2">Recently viewed</h2></div><div class="rail">' + joined + '</div></div>';
    } catch (_) {}
  });

  }
  initLazy();

  /* sort select */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-sort]'); if (!sel) return;
    const url = new URL(location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page');
    location.href = url.toString();
  });

  /* gender tabs (home categories) */
  $$('[data-cat-tabs]').forEach((root) => {
    const tabs = $$('[data-tab]', root), panels = $$('[data-panel]', root);
    if (!tabs.length) return;
    function show(name, focus) {
      tabs.forEach((t) => { const on = t.dataset.tab === name; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      panels.forEach((p) => { p.hidden = p.dataset.panel !== name; });
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(t.dataset.tab));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        show(n.dataset.tab, true);
      });
    });
    show(tabs[0].dataset.tab);
  });

  /* share */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-share]'); if (!b) return;
    const url = b.getAttribute('data-share');
    if (navigator.share) navigator.share({ url, title: document.title }).catch(() => {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => { b.textContent = 'Link copied'; });
  });
})();
